export default __webpack_public_path__ + "static/v1_2-d59659ecae09302af4f945b53c516ae4.webp";